import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useSessionId, ThemeContext, useAuthProvider, Api, Loader } from "@cloudpremise/portal_core";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import MDInput from "@cloudpremise/portal_core/src/themes/mui/components/MDInput";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";
import MDSelect from "@cloudpremise/portal_core/src/themes/mui/components/MDSelect";
import AccountModal from "../components/AccountModal";
import Confirmation from  "@cloudpremise/portal_core/src/themes/mui/components/Modals/Confirmation";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import { useIsAuthenticated } from '@azure/msal-react';
import { useMsal } from "@azure/msal-react";

const SObjectApi = (props) => {
    let defaultState = {
        AccountId: "",
        apiType: "standard",
        apiTypeSelection: [{id: 'standard', label: 'Standard Api'}],
        loading: false,
        sobject: null,
        accountModal: false,
        deleteModal: false,
        errorMessage: null
    };
    const [state, setState] = React.useReducer((state: any, newState: Partial<any>) => ({
        ...state,
        ...newState
    }), defaultState);

    const apiTypes = [
        {
            'id': 'standard',
            'label': 'Standard Api'
        },
        {
            'id': 'internal',
            'label': 'Internal Api'
        }
    ];

    function handleChange(event, name){
        setState({
            [name]: event.target.value
        });
    }
    function onSelectChange(newValue, name){
        setState({
            [name]: (newValue ? newValue.id : 'standard')
        });
    }
    function loadSObject(){
        if(state.AccountId.length <= 0){
            return;
        }
        Api.apiType = state.apiType;
        Api.callApi({sobjecttypename: "Account", Id: state.AccountId}, 'GET', {}, {}).then(data => {
            setState({
                sobject: data,
                accountModal: true,
                loading: false,
                errorMessage: null
            });
        }).catch(err => {
            if(typeof(err) === "object" && err.hasOwnProperty("error")){
                err['message'] = err.error;
            }
            setState({
                loading: false,
                errorMessage: err.message
            });
        });
        setState({
            loading: true,
            errorMessage: null
        });
    }
    function onAccountModal(status = false){
        Api.apiType = state.apiType;
        setState({
            accountModal: status,
            errorMessage: null,
            sobject: null
        });
    }
    function onAccountModalSuccess(id){
        setState({
            accountModal: false,
            AccountId: id,
            sobject: null,
            errorMessage: null
        });
    }
    function handleRowAction(item, action){
        let newState = {
            [action.value+"Modal"]: true
        };
        setState(newState);      
	}
    function onConfirmationModal(status = true){
        setState({
            deleteModal: status,
            errorMessage: null
        });
    }
    function onDeleteModalSuccess(){
        let method = 'DELETE';
        let data = [state.AccountId];
        Api.callApi({sobjecttypename: "Account", Id: state.AccountId}, method, data).then(data => {
            setState({
                accountModal: false,
                deleteModal: false,
                errorMessage: null
            });
        }).catch(err => {
            setState({
                accountModal: false,
                deleteModal: false,
                errorMessage: err.message
            });
        });

        setState({
            saving: true,
            errorMessage: null
        });
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={3}>
                <Grid container justifyContent="flex-start" alignItems="flex-start">
                    <MDBox mr={2}>
                        <MDSelect
                            defaultValue="Standard Api"
                            options={apiTypes}
                            label="Api Type"
                            onChange={(event: any, newValue) => onSelectChange(newValue, 'apiType')}
                            disableClearable
                            sx={{width: "150px"}}
                        />
                    </MDBox>
                    <MDBox mr={2}>
                        <MDInput 
                            label="Account Id"
                            onChange={(event) => handleChange(event, "AccountId")}
                            value={state.AccountId}
                            sx={{width: "200px"}}
                        />
                    </MDBox>
                    <MDBox>
                        <MDButton
                            variant="gradient"
                            onClick={() => loadSObject()}
                            color="info"
                            sx={{marginRight: "16px"}}
                        >
                            Get Account
                        </MDButton>
                        <MDButton
                            variant="gradient"
                            onClick={() => onAccountModal(true)}
                            color="info"
                        >
                            Create Account
                        </MDButton>
                    </MDBox>
                </Grid>
            </MDBox>
            {
                state.loading ?
                    <Loader color="info" />
                :
                    state.accountModal ?
                        <AccountModal
                            item={state.sobject}
                            open={true}
                            onCancel={() => onAccountModal()}
                            onSuccess={(id) => onAccountModalSuccess(id)}
                            onDelete={onDeleteModalSuccess}
                            onObjectAction={(action) => handleRowAction(state.row, {value: action})}
                        />
                    :
                    null
            }
            {
                state.deleteModal ?
                    <Confirmation
                        open={state.deleteModal}
                        item={state.sobject}
                        onCancel={() => onConfirmationModal(false)}
                        onSuccess={onDeleteModalSuccess}
                        message={"Are you sure you want to delete?"}
                        saving={state.saving}
                        errorMessage={state.errorMessage}
                    />
                :
                null
            }
        </DashboardLayout>
    )
};

export default SObjectApi;